export default {
    'title': 'Settings',
    'tab.general': 'General',
    'tab.numbering': 'Numbering',
    'tab.laboratory': 'Laboratory',
    'tab.billing': 'Billing & tax',
    'tab.integrations': 'Integrations',
    'tab.about': 'About & updates',
    'general.identity': 'Identity and branding',
    'general.display_name': 'Display name',
    'general.primary_colour': 'Primary colour',
    'general.language': 'Language',
    'general.policy': 'Clinical and financial policy',
    'general.read_only': 'You can view these settings but not change them.',
    'saved': 'Settings saved',
    'save_failed': 'Could not save the settings',
    'branch.country': 'Country',
    'branch.currency': 'Currency',
    'branch.country_hint': 'Decides the currency, tax rules and ID documents. It locks once tax details or the first bill are recorded.',
    'branch.country_locked': 'Locked: this branch already has its tax registration recorded',
    'tax.title': 'Tax registration',
    'tax.registration_number': 'Registration number',
    'tax.legal_name': 'Legal name',
    'tax.legal_name_local': 'Legal name in Arabic',
    'tax.company_number': 'Company registration number',
};
//# sourceMappingURL=settings.js.map